// extracted by css-extract-rspack-plugin
export default {"root":"lP6A1XdR7fguwfK_"};